document.addEventListener('DOMContentLoaded', function () {

  /* ---------- Pesquisa ---------- */
  var searchToggle = document.getElementById('SearchToggle');
  var predictiveSearch = document.getElementById('PredictiveSearch');
  if (searchToggle && predictiveSearch) {
    searchToggle.addEventListener('click', function () {
      predictiveSearch.hidden = !predictiveSearch.hidden;
    });
  }

  /* ---------- Miniaturas de produto ---------- */
  document.querySelectorAll('.product-thumb').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var mainImg = document.getElementById('ProductMainImage');
      if (mainImg) mainImg.src = thumb.dataset.full;
    });
  });

  /* ---------- Pills de opção (variantes) ---------- */
  document.querySelectorAll('.product-option').forEach(function (optionBlock) {
    var select = optionBlock.querySelector('.visually-hidden-select');
    var pills = optionBlock.querySelectorAll('.option-pill');
    pills.forEach(function (pill, i) {
      if (i === 0) pill.classList.add('is-selected');
      pill.addEventListener('click', function () {
        pills.forEach(function (p) { p.classList.remove('is-selected'); });
        pill.classList.add('is-selected');
        if (select) {
          select.value = pill.dataset.optionValue;
          select.dispatchEvent(new Event('change'));
        }
      });
    });
  });

  /* ---------- Seletor de quantidade ---------- */
  document.querySelectorAll('.qty-selector').forEach(function (selector) {
    var input = selector.querySelector('input');
    selector.querySelectorAll('.qty-selector__btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var val = parseInt(input.value, 10) || 1;
        val = btn.dataset.qty === 'increase' ? val + 1 : Math.max(1, val - 1);
        input.value = val;
      });
    });
  });

  /* ---------- Barra fixa de adicionar ao carrinho ---------- */
  var stickyBar = document.getElementById('StickyAddBar');
  var addToCartBtn = document.getElementById('AddToCartBtn');
  var stickyAddBtn = document.getElementById('StickyAddBtn');
  if (stickyBar && addToCartBtn) {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        stickyBar.classList.toggle('is-visible', !entry.isIntersecting);
      });
    }, { threshold: 0 });
    observer.observe(addToCartBtn);

    if (stickyAddBtn) {
      stickyAddBtn.addEventListener('click', function () {
        addToCartBtn.click();
      });
    }
  }

  /* ---------- Carrossel de coleções ---------- */
  var viewport = document.getElementById('CarouselViewport');
  if (viewport) {
    var slides = viewport.querySelectorAll('.carousel-slide');
    var total = slides.length;
    var current = 0;
    var autoplayTimer = null;
    var isPlaying = true;
    var prevBtn = document.getElementById('CarouselPrev');
    var nextBtn = document.getElementById('CarouselNext');
    var playBtn = document.getElementById('CarouselPlay');
    var currentEl = document.getElementById('CarouselCurrent');
    var iconPause = playBtn ? playBtn.querySelector('.icon-pause') : null;
    var iconPlay = playBtn ? playBtn.querySelector('.icon-play') : null;

    function goTo(index) {
      current = (index + total) % total;
      viewport.style.transform = 'translateX(-' + (current * 100) + '%)';
      if (currentEl) currentEl.textContent = current + 1;
    }

    function next() { goTo(current + 1); }
    function prev() { goTo(current - 1); }

    function startAutoplay() {
      var seconds = parseInt(viewport.closest('.collection-carousel').dataset.autoplay || 5, 10);
      autoplayTimer = setInterval(next, seconds * 1000);
    }
    function stopAutoplay() {
      clearInterval(autoplayTimer);
    }

    if (nextBtn) nextBtn.addEventListener('click', function () { next(); stopAutoplay(); if (isPlaying) startAutoplay(); });
    if (prevBtn) prevBtn.addEventListener('click', function () { prev(); stopAutoplay(); if (isPlaying) startAutoplay(); });

    if (playBtn) {
      playBtn.addEventListener('click', function () {
        isPlaying = !isPlaying;
        if (isPlaying) {
          startAutoplay();
          if (iconPause) iconPause.hidden = false;
          if (iconPlay) iconPlay.hidden = true;
        } else {
          stopAutoplay();
          if (iconPause) iconPause.hidden = true;
          if (iconPlay) iconPlay.hidden = false;
        }
      });
    }

    if (total > 1) startAutoplay();
  }

  /* ---------- Drawer do carrinho ---------- */
  var drawer = document.getElementById('CartDrawer');
  var toggleBtn = document.getElementById('CartDrawerToggle');
  var cartUrl = toggleBtn ? toggleBtn.dataset.cartUrl : '/cart';

  function openDrawer() {
    if (!drawer) return;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }

  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  function refreshDrawer(thenOpen) {
    fetch(cartUrl + '?section_id=cart-drawer')
      .then(function (res) { return res.text(); })
      .then(function (html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var newDrawer = doc.getElementById('CartDrawer');
        if (newDrawer && drawer) {
          drawer.innerHTML = newDrawer.innerHTML;
          bindDrawerEvents();
        }
        updateCartCount();
        if (thenOpen) openDrawer();
      })
      .catch(function () { if (thenOpen) openDrawer(); });
  }

  function updateCartCount() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var countEl = document.getElementById('CartCount');
        if (countEl) countEl.textContent = cart.item_count;
      });
  }

  function bindDrawerEvents() {
    var newOverlay = document.getElementById('CartDrawerOverlay');
    var newClose = document.getElementById('CartDrawerClose');
    if (newOverlay) newOverlay.addEventListener('click', closeDrawer);
    if (newClose) newClose.addEventListener('click', closeDrawer);

    document.querySelectorAll('.qty-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var line = btn.dataset.line;
        var span = btn.parentElement.querySelector('span');
        var qty = parseInt(span.textContent, 10);
        qty = btn.dataset.action === 'increase' ? qty + 1 : qty - 1;
        changeLine(line, qty);
      });
    });

    document.querySelectorAll('.cart-drawer__item-remove').forEach(function (btn) {
      btn.addEventListener('click', function () {
        changeLine(btn.dataset.line, 0);
      });
    });

    var clearBtn = document.getElementById('CartDrawerClear');
    if (clearBtn) {
      clearBtn.addEventListener('click', function () {
        fetch('/cart/clear.js', { method: 'POST' }).then(function () { refreshDrawer(false); });
      });
    }

    document.querySelectorAll('.cart-drawer__rec-form').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var formData = new FormData(form);
        fetch('/cart/add.js', { method: 'POST', body: formData, headers: { 'Accept': 'application/json' } })
          .then(function () { refreshDrawer(false); });
      });
    });
  }

  function changeLine(line, quantity) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    }).then(function () { refreshDrawer(false); });
  }

  if (toggleBtn) {
    toggleBtn.addEventListener('click', function (e) {
      e.preventDefault();
      refreshDrawer(true);
    });
  }

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeDrawer();
  });

  bindDrawerEvents();

  /* ---------- Adicionar ao carrinho via AJAX ---------- */
  document.querySelectorAll('form[action^="/cart/add"]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      e.stopPropagation();
      var formData = new FormData(form);
      var submitBtn = form.querySelector('button[type="submit"]');
      if (submitBtn) submitBtn.disabled = true;
      fetch('/cart/add.js', {
        method: 'POST',
        body: formData,
        headers: { 'Accept': 'application/json' }
      })
        .then(function (res) { return res.json(); })
        .then(function () { refreshDrawer(true); })
        .catch(function () { form.submit(); })
        .finally(function () { if (submitBtn) submitBtn.disabled = false; });
    });
  });

  /* ---------- Cartão de produto: clique no botão de adicionar ao carrinho sem seguir o link ---------- */
  document.querySelectorAll('.product-card__quick-add').forEach(function (form) {
    form.addEventListener('click', function (e) { e.stopPropagation(); });
  });

  /* ---------- Favoritos (guardados no navegador do cliente) ---------- */
  var WISHLIST_KEY = 'hitnails_wishlist';

  function getWishlist() {
    try {
      return JSON.parse(localStorage.getItem(WISHLIST_KEY)) || [];
    } catch (e) {
      return [];
    }
  }

  function saveWishlist(list) {
    localStorage.setItem(WISHLIST_KEY, JSON.stringify(list));
  }

  function showToast(message) {
    var toast = document.getElementById('SiteToast');
    if (!toast) {
      toast = document.createElement('div');
      toast.className = 'site-toast';
      toast.id = 'SiteToast';
      document.body.appendChild(toast);
    }
    toast.textContent = message;
    toast.classList.add('is-visible');
    clearTimeout(toast._hideTimer);
    toast._hideTimer = setTimeout(function () {
      toast.classList.remove('is-visible');
    }, 2200);
  }

  function updateWishlistCount() {
    var count = getWishlist().length;
    var badge = document.getElementById('WishlistCount');
    if (badge) {
      badge.textContent = count;
      badge.setAttribute('data-empty', count === 0 ? 'true' : 'false');
    }
  }

  function syncWishlistButtons() {
    var ids = getWishlist().map(function (item) { return String(item.id); });
    document.querySelectorAll('[data-wishlist-toggle]').forEach(function (btn) {
      btn.classList.toggle('is-active', ids.indexOf(String(btn.dataset.wishlistId)) !== -1);
    });
  }

  document.querySelectorAll('[data-wishlist-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();

      var id = String(btn.dataset.wishlistId);
      var list = getWishlist();
      var idx = list.findIndex(function (item) { return String(item.id) === id; });

      if (idx > -1) {
        list.splice(idx, 1);
        showToast('Removido dos favoritos');
      } else {
        list.push({
          id: id,
          handle: btn.dataset.wishlistHandle,
          title: btn.dataset.wishlistTitle,
          price: btn.dataset.wishlistPrice,
          image: btn.dataset.wishlistImage,
          url: btn.dataset.wishlistUrl
        });
        showToast('Adicionado aos favoritos');
      }

      saveWishlist(list);
      updateWishlistCount();
      syncWishlistButtons();
      if (typeof renderWishlistPage === 'function') renderWishlistPage();
    });
  });

  function renderWishlistPage() {
    var grid = document.getElementById('WishlistGrid');
    var emptyMsg = document.getElementById('WishlistEmpty');
    if (!grid) return;

    var list = getWishlist();
    grid.innerHTML = '';

    if (list.length === 0) {
      if (emptyMsg) emptyMsg.style.display = 'block';
      return;
    }
    if (emptyMsg) emptyMsg.style.display = 'none';

    list.forEach(function (item) {
      var card = document.createElement('div');
      card.className = 'product-card';
      card.innerHTML =
        '<a href="' + item.url + '" class="product-card__link">' +
          '<div class="product-card__media">' +
            (item.image ? '<img src="' + item.image + '" alt="' + item.title + '" loading="lazy">' : '') +
          '</div>' +
          '<p class="product-card__title">' + item.title + '</p>' +
          '<p class="product-card__price">' + item.price + '</p>' +
        '</a>' +
        '<button type="button" class="wishlist-remove" data-remove-id="' + item.id + '" aria-label="Remover dos favoritos">' +
          '<svg width="16" height="16" viewBox="0 0 24 24"><path d="M20.8 4.6a5.5 5.5 0 0 0-7.8 0L12 5.6l-1-1a5.5 5.5 0 0 0-7.8 7.8l1 1L12 21.2l7.8-7.8 1-1a5.5 5.5 0 0 0 0-7.8z"/></svg>' +
        '</button>';
      grid.appendChild(card);
    });

    grid.querySelectorAll('.wishlist-remove').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var id = String(btn.dataset.removeId);
        var updated = getWishlist().filter(function (i) { return String(i.id) !== id; });
        saveWishlist(updated);
        updateWishlistCount();
        renderWishlistPage();
      });
    });
  }

  updateWishlistCount();
  syncWishlistButtons();
  renderWishlistPage();

  /* ---------- Menu mobile (hamburger) ---------- */
  var navToggle = document.getElementById('NavToggle');
  var siteNav = document.getElementById('SiteNav');
  var navOverlay = document.getElementById('NavOverlay');

  function openNav() {
    siteNav.classList.add('is-open');
    navOverlay.classList.add('is-open');
    navToggle.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
  }
  function closeNav() {
    siteNav.classList.remove('is-open');
    navOverlay.classList.remove('is-open');
    navToggle.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
    siteNav.querySelectorAll('li.is-open').forEach(function (li) {
      li.classList.remove('is-open');
    });
  }

  if (navToggle && siteNav && navOverlay) {
    navToggle.addEventListener('click', function () {
      siteNav.classList.contains('is-open') ? closeNav() : openNav();
    });
    navOverlay.addEventListener('click', closeNav);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeNav();
    });

    /* transforma os itens com submenu em acordeão só em mobile */
    siteNav.querySelectorAll('.nav-caret').forEach(function (caret) {
      caret.addEventListener('click', function (e) {
        if (window.innerWidth > 768) return;
        e.preventDefault();
        e.stopPropagation();
        var li = caret.closest('li');
        var wasOpen = li.classList.contains('is-open');
        li.parentElement.querySelectorAll(':scope > li.is-open').forEach(function (openLi) {
          if (openLi !== li) openLi.classList.remove('is-open');
        });
        li.classList.toggle('is-open', !wasOpen);
      });
    });
  }
});
